import { combineReducers } from 'redux';
import { toggleReducer } from 'frontend/state/utils';
import types from 'frontend/state/actionTypes';

export default combineReducers({
  open: toggleReducer({
    toggle: types.TOGGLE_REPORT_OPTIONS,
    initial: false,
  }),
});

const baseSelector = state => state.simbot.reportOptions;
const openSelector = state => baseSelector(state).open;

export const selectors = {
  open: openSelector,
};
